/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DatePicker } from 'antd';

import { Form } from '@organisms';

const DateField = ({ Dateformat = 'DD/MM/YYYY', disabledDate, ...props }) => {
  return (
    <Form.Item {...props}>
      <DatePicker format={Dateformat} disabledDate={disabledDate} />
    </Form.Item>
  );
};

export default DateField;
